import { NOTIFICATIONTYPE } from "Store/Notification/ActionTypes";
import { StoreState } from "Store/Reducers";

export const getActionType = (input: string) => ({
    REQUEST: '[REQUEST]' + input.toUpperCase(),
    SUCCESS: '[SUCCESS]' + input.toUpperCase(),
    FAILURE: '[FAILURE]' + input.toUpperCase()
});

export const getActionTypes = (input: string) => Object.values(getActionType(input));

export type ACTION_TYPE = {
    types: string[],
    shouldCallAPI?: (state: StoreState) => boolean,
    shouldRequestInBackground?: (state: StoreState) => boolean,
    notification?: {
        [NOTIFICATIONTYPE.SUCCESS]: string,
        [NOTIFICATIONTYPE.LOADING]?: string,
        [NOTIFICATIONTYPE.ERROR]: string
    },
    callAPI: {
        url: string,
        method?: 'POST' | 'PATCH' | 'DELETE' | 'PUT',
        body?: {},
        formData?: any
    },
    callback?: ACTION_TYPE,
    parralel?: ACTION_TYPE,
    payload?: any
}